export default "__VITE_ASSET__B0F59Qsp__"